import { Component, Input } from '@angular/core'

@Component({
  selector: 'shared-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.css'],
  standalone: false
})
export class LogoComponent {
  @Input() link: string = '/projects'
  @Input() logoUrl: string = "assets/logo.png"

  get isInternalLink(): boolean {
    return !this.link?.startsWith('http')
  }
}